module.exports = __webpack_public_path__ + "static/img/rule-tikbee.624cb551.png";